import type { ChipColor } from '@/components/base/BaseChip.vue'
import type { CustomerOrder, OrderChannelSlug, OrderStatusSlug } from '@/types/customer/Order'

const CHANNEL_COLORS: Record<OrderChannelSlug, ChipColor> = {
  pos: 'blue',
  touchscreen: 'violet',
  web: 'emerald'
}

const STATUS_COLORS: Record<Exclude<OrderStatusSlug, 'closed'>, ChipColor> = {
  opened: 'gray',
  processing: 'yellow',
  canceled: 'red'
}

const isKnownSlug = <T extends string>(colors: Record<T, ChipColor>, slug?: string | null): slug is T =>
  !!slug && Object.prototype.hasOwnProperty.call(colors, slug)

export const getChannelChip = (slug?: string | null): { color: ChipColor; labelKey: string } =>
  isKnownSlug(CHANNEL_COLORS, slug)
    ? { color: CHANNEL_COLORS[slug], labelKey: `channels.${slug}` }
    : { color: 'gray', labelKey: 'channels.unknown' }

export const getStatusChip = (slug?: string | null): { color: ChipColor; labelKey: string } | null =>
  isKnownSlug(STATUS_COLORS, slug) ? { color: STATUS_COLORS[slug], labelKey: `statuses.${slug}` } : null

export const hasDiscount = (order: Pick<CustomerOrder, 'discountAmount'>): boolean => order.discountAmount > 0

export const hasDiscountsOrRewards = (order: Pick<CustomerOrder, 'coupons' | 'rewards' | 'discountAmount'>): boolean =>
  order.coupons.length > 0 || order.rewards.length > 0 || hasDiscount(order)
